import JobIndex from "./JobIndex";

export default JobIndex;
